function transformCheckoutParameters(parameters) {
    var items = [];

    if (parameters.products && parameters.products.length > 0) {
        const accessories = parameters.products[0].accessories;
        if (Array.isArray(accessories) && accessories.length > 0) {
            accessories.forEach(function(accessory) {
                if (accessory && accessory.productId) {
                    items.push({
                        id: accessory.productId,
                        quantity: accessory.quantity
                    });
                }
            });
        }
    }

    return items;
}
window.Combeenation = (window.Combeenation || {});
window.Combeenation.onCheckout = function (data) {
    const containers = Array.from(document.querySelectorAll('[data-section-type="page-combeenation"]'));
    if (!containers) {
        return;
    }

    if (!containers.length) {
        return;
    }

    containers.forEach((container) => {
        const sectionId = container.getAttribute('data-section-id');
        if (!sectionId) {
            return;
        }

        var sectionElement = document.getElementById(`section-${sectionId}`);

        if (sectionElement) {
            sectionElement.classList.add('active');
        }
        var jsonData = JSON.parse(data.checkoutParameters);
        console.log("Data: " + data.checkoutParameters);
        console.log("jsonData: " + jsonData);

        var transformedData = transformCheckoutParameters(jsonData);
        console.log("Data: " + transformedData);

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({items: transformedData})
        })
            .then(response => {
                if (!response.ok) {
                    throw response;
                }
                return response.json();
            })
            .then(data => {
                console.log('nice: ', data);
                if (sectionElement) {
                    sectionElement.classList.remove('active');
                }
            })
            .catch(async (error) => {
                let errorMessage = 'An error occurred';
                if (error.json) {
                    try {
                        const errorData = await error.json();
                        errorMessage = errorData.description || errorMessage;
                    } catch (e) {
                        errorMessage = error.statusText || errorMessage;
                    }
                }
                console.error('Error: ', errorMessage);
            });


        console.log("Parent page here, checkout is finished. Data: " + data.checkoutParameters);
        console.log("Data: " + data);
    });
};

function sendConfigurationSummaryEvent() {
    window.dataLayer.push({
        'event': 'configuration_summary'
    });
}
function sendConfigurationSaveEvent() {
    window.dataLayer.push({
        'event': 'configuration_save'
    });
}
function sendConfigurationShareEvent() {
    window.dataLayer.push({
        'event': 'configuration_share'
    });
}
function sendConfigurationCartEvent() {
    window.dataLayer.push({
        'event': 'configuration_cart'
    });
}
function sendConfigurationBuildEvent() {
    window.dataLayer.push({
        'event': 'configuration_build'
    });
}
function sendConfigurationChooseEvent() {
    window.dataLayer.push({
        'event': 'configuration_choose'
    });
}
function sendConfigurationCDREvent() {
    window.dataLayer.push({
        'event': 'configuration_cdr'
    });
}
function sendConfigurationStartEvent() {
    window.dataLayer.push({
        'event': 'configuration_start'
    });
}
const eventHandlers = {
    'configuration_start': sendConfigurationStartEvent,
    'configuration_summary': sendConfigurationSummaryEvent,
    'configuration_save': sendConfigurationSaveEvent,
    'configuration_share': sendConfigurationShareEvent,
    'configuration_cart': sendConfigurationCartEvent,
    'configuration_build': sendConfigurationBuildEvent,
    'configuration_choose': sendConfigurationChooseEvent,
    'configuration_cdr': sendConfigurationCDREvent
};

function handleEvent(event) {
    const handler = eventHandlers[event];
    if (handler) {
        handler();
    }
}

window.addEventListener("message", (event) => {
    handleEvent(event.data.event);
});
